import { GETDYNAMICFIELDS_SUCCESS, GETDYNAMICFIELDS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getDynamicFieldReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETDYNAMICFIELDS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETDYNAMICFIELDS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getDynamicFieldReducer;
